import { LoadingState } from "../../../type/loading-state";

export const startCenterLoadingDispatch = (state: LoadingState) => {
    state.globalLoading = true;
    state.isDim = false;
};
